// ParthipanDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import parthipanImg from '../../../../assets/images/Doctorsimages/dr.parthipan.png' 
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const ParthipanDoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    document.title = "Dr. Parthipan | Dedicated Homeopathic Consultant | Holistic Health & Wellness Expert";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Parthipan (BHMS), a committed homeopathic consultant specializing in holistic healing and natural wellness. Expert in treating the root cause of ailments with personalized care."
      );
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor, homeopathic consultant, holistic healing specialist, natural medicine expert, Dr. Parthipan homeopathy, homeopathy for chronic illness, root cause treatment, Martin Homoeopathic Medical College graduate, M.G.R University doctor, personalized homeopathic care, wellness consultant, gentle healing therapies, homeopathy for lifestyle disorders"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-parthipan/homeopathy-consultant-coimbatore";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
      img.style.display = 'block';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        imageTimeout: 0
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;

        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save('Dr.Parthipan_Profile.pdf');
      }).catch(err => {
        console.error("PDF Generation Error:", err);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 500);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Parthipan</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Coimbatore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A dedicated and compassionate Homeopathic Consultant who brings a fresh, modern perspective to the time-honored science of homeopathy. Focused on delivering gentle, permanent, and side-effect-free healing by addressing the fundamental imbalance within the body.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={parthipanImg} 
                        alt="Dr. Parthipan – Consultant in Homeopathy" 
                        className="veenadoc-doctor-image" 
                        crossOrigin="anonymous"
                        title='Dr. Parthipan – Consultant in Homeopathy' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Parthipan</h2>
                  <p>
                    Dr. Parthipan earned his Bachelor of Homoeopathic Medicine and Surgery (BHMS) from the esteemed <strong>Martin Homoeopathic Medical College and Hospital</strong>, affiliated with the prestigious <strong>Tamil Nadu Dr. M.G.R. Medical University</strong>. 
                  </p>
                  <p>
                    His academic training has equipped him with a comprehensive understanding of both classical homeopathic principles and modern medical diagnostics, allowing him to provide well-rounded clinical care.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Expertise & Approach</h2>
                  <p>
                    Currently serving as a Consultant, Dr. Parthipan has spent his first year of practice immersing himself in diverse clinical cases. He is known for his meticulous case-taking process, where he explores the physical, emotional, and lifestyle factors contributing to health concerns.
                  </p>
                  <p>
                    This thoroughness ensures that the remedies prescribed are precisely tailored to the individual’s specific needs, promoting long-term recovery and vitality.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">1 Year</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathic Consultant</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">College:</span>
                      <span className="veenadoc-info-value">Martin Homoeopathic Medical College</span>
                    </div>
                  </div>
                </div>

                {/* Holistic Healing */}
                <div className="veenadoc-article-block">
                  <h2>Holistic Health & Wellness</h2>
                  <p>
                    Dr. Parthipan’s approach is rooted in the belief that the body possesses an inherent ability to heal itself when given the right stimulus. He specializes in managing a wide range of acute and chronic conditions.
                  </p>
                  <p>
                    By combining his medical expertise with an empathetic listening style, he creates a supportive environment where patients feel heard and understood throughout their healing journey.
                  </p>
                </div>

                {/* Patient-Centric Care */}
                <div className="veenadoc-article-block">
                  <h2>A Fresh Perspective on Homeopathy</h2>
                  <p>
                    As a rising professional, Dr. Parthipan is committed to staying at the forefront of medical advancements while maintaining the core values of holistic medicine. He prioritizes long-term wellness and individualized care for every patient.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Parthipan for Holistic Restoration</h2>
                  <p>
                    Patients seeking a dedicated professional who focuses on the root cause of ailments will find Dr. Parthipan to be a reliable partner. He provides the expertise and compassion necessary for true health restoration.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His mission:</strong> To empower patients through natural, side-effect-free healing and restore the body's natural harmony.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "True healing begins when we treat the individual, not just the illness, by restoring the body's natural harmony."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Parthipan's Philosophy</p>
                  </div>
                  <p>
                    This patient-first mindset ensures that care is not only effective but also deeply respectful of the patient’s journey toward health.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Coimbatore</h4>
                      <p>H-Cura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Start your health journey with Dr. Parthipan's dedicated homeopathic care.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default ParthipanDoc;
